export let siteConfig = {}
switch (window.location.host) {
    case "field.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://myapps.microsoft.com/signin/Dev-SAML/c885aa95-b051-4a65-98db-f3eef862e063?tenantId=90e4dd40-75ba-4589-9ca9-53b1970ad772",
            btnAD_title: 'Login Voolks Azure ActiveDirectory ',
            webapp: [{ url: "https://webapp.voolks.com", logo: "", title: "Field App" }, { url: "https://permisosdetrabajo.voolks.com", logo: "", title: "Permisos de Trabajo" }]
        }
        break;
    case "field-test.voolks.com":
    case "127.0.0.1:3000":
    // case "localhost:3000":
        siteConfig = {
            AuthStrategy: "SAML",
            productName: "Field Test By Vöolks",primaryColor : "#6c617cff",
            urlUserAccess: "https://myapps.microsoft.com/signin/Dev-SAML/c885aa95-b051-4a65-98db-f3eef862e063?tenantId=90e4dd40-75ba-4589-9ca9-53b1970ad772",
            btnAD_title: 'Login Voolks Azure ActiveDirectory ',
            webapp: [{ url: "https://webapp-test.voolks.com", logo: "", title: "Field App TEST" }, { url: "https://permisosdetrabajo-test.voolks.com", logo: "", title: "Permisos de Trabajo TEST" }],
            sheetsApiBase: "https://sheets-test.voolks.com/api",
            sheetsFrontUrl: "https://sheets-test.voolks.com"
        }
        break;
    // case "localhost:3000":
    case "pampageneracion.voolks.com":
    case "pampaenergia-test.voolks.com":
    case "pampaenergia.voolks.com":
    case "pampa.voolks.com":
    case "pampa-test.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://myapps.microsoft.com/signin/b02336f0-8a4f-4775-8c08-17850fc93772?tenantId=eef41338-8caf-4011-87bf-ff1c9c425f9e",
            btnAD_title: 'Login Pampa Azure AD ',
            logo: "./images/pampaEnergiaWhite_logo.png",
            navlogo: "./images/pampa-navlogo.png",
            // tags: ["certdigital"],
            webapp: [{ url: "https://pampaenergia-app.voolks.com", logo: "", title: "Field Pampa" }, { url: "https://pdtpampa.voolks.com", logo: "", title: "Permisos de Trabajo" }]
        }
        break;
    // case "localhost:3000":
    case "pampa-cd.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://launcher.myapps.microsoft.com/api/signin/53d0212a-52cd-45eb-93f6-77d5681b774d?tenantId=eef41338-8caf-4011-87bf-ff1c9c425f9e",
            btnAD_title: 'Login PAMPA ENERGIA AD ',
            loginTitle: "Certificación Digital",
            navlogo: "./images/pampa-navlogo.png",
            productLogo: "./images/pampa-navlogo.png",
            productName: "Certificación Digital",
            productFavIcon: "/pampa-certdig.ico",
            primaryColor: "#00a7f3",
            viewerToWebapp: 0,
            supervisorHideSideBar: true,
            deptsId: ["677c416a908e1747081daa00"],
            tags: ["certdigital"],
            webapp: [{ urldev: "http://localhost:19006/", url: "https://pampa-cdapp.voolks.com/", logo: "", title: "Carga de Proveedores" }]
        }
        break;
    case "localhost:3000":
    case "pampa-certdigtest.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://myapps.microsoft.com/signin/b02336f0-8a4f-4775-8c08-17850fc93772?tenantId=eef41338-8caf-4011-87bf-ff1c9c425f9e",
            btnAD_title: 'Login PAMPA ENERGIA AD ',
            loginTitle: "Certificación Digital",
            navlogo: "./images/pampa-navlogo.png",
            productLogo: "./images/pampa-navlogo.png",
            productName: "Certificación Digital",
            productFavIcon: "/pampa-certdig.ico",
            primaryColor: "#00a7f3",
            viewerToWebapp: 0,
            supervisorHideSideBar: true,
            deptsId: ["677c416a908e1747081daa00"],
            tags: ["certdigital"],
            webapp: [{ urlDev: "http://localhost:19006/", url: "https://certdig-test.voolks.com/", logo: "", title: "Carga de Proveedores" }]
        }
        break;
    case "edenor.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://myapps.microsoft.com/signin/%5Be%5D%20Voolks%20Field/f199ed31-2f4c-4707-80dc-e613e6e9dac2?tenantId=521e430f-ba3c-4d47-9f97-16b945b0a850",
            btnAD_title: 'Login EDENOR AD ',
            logo: "./images/edenorWhite_logo.png",
            navlogo: "./images/edenor-navlogo.png",
            serverUrl: "https://edenor.voolks.com/api/",
            webapp: [{ url: "https://edenor-app.voolks.com", logo: "", title: "Field Edenor" }, { url: "https://permisosdetrabajo.voolks.com", logo: "", title: "Permisos de Trabajo" }]
        }
        break;
    //case "localhost:3000":
    case "cgc.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://launcher.myapps.microsoft.com/api/signin/39012253-eaa6-41cb-92f1-9847c7bfcd6a?tenantId=5260614a-627f-43fe-9115-05b4394e730e",
            btnAD_title: 'Login CGC AD',
            logo: "./images/cgclogoNegro.png",
            primaryColor: "#00827b",
            navlogo: "./images/cgclogoNav.png",
            serverUrl: "https://cgc.voolks.com/api/",
            webapp: [{ url: "https://cgc-app.voolks.com", logo: "", title: "Field CGC" }, { url: "https://permisosdetrabajo.voolks.com", logo: "", title: "Permisos de Trabajo" }]
        }
        break;
    case "mbtrucks.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://www.voolks.com/",
            btnAD_title: 'Login MB AD',
            logo1: "./images/cgclogoNegro.png",
            primaryColor: "#222a32",
            navlogo1: "./images/cgclogoNav.png",
            serverUrl: "https://mbtrucks.voolks.com/api/",
            webapp: [{ url: "https://mbtrucks-app.voolks.com", logo: "", title: "Field MB" }, { url: "https://permisosdetrabajo.voolks.com", logo: "", title: "Permisos de Trabajo" }]
        }
        break;
    case "edenor-test.voolks.com":
        siteConfig = {
            AuthStrategy: "SAML",
            urlUserAccess: "https://myapps.microsoft.com/signin/Voolks%20Field%20Test/8e06afac-2fce-4df1-b6d1-cb1a604603bb?tenantId=521e430f-ba3c-4d47-9f97-16b945b0a850",
            btnAD_title: 'Login EDENOR AD ',
            logo: "./images/edenorWhite_logo.png",
            navlogo: "./images/edenor-navlogo.png",
            serverUrl: "https://edenor-test.voolks.com/api/"
        }
        break;
    default:
        siteConfig = {};
}

// Para HTML de datagrid
if (!siteConfig.hasOwnProperty('serverUrl')) {
    if (!['localhost', '127.0.0.1'].includes(window.location.hostname)) {
        siteConfig.serverUrl = window.location.origin + "/api/";
    }
}
siteConfig.deptsId = siteConfig.deptsId || [];
siteConfig.tags = siteConfig.tags || [];
siteConfig.productLogo = siteConfig.productLogo || "./images/field_logo.png"
siteConfig.productName = siteConfig.productName || "Field By Vöolks"
siteConfig.primaryColor = siteConfig.primaryColor || "#3957FC"
siteConfig.sheetExample = "./images/validators-example-sheet.png"
siteConfig.webapp = siteConfig.webapp || [{ url: "https://webapp.voolks.com", logo: "", title: "Field App" }, { url: "https://permisosdetrabajo.voolks.com", logo: "", title: "Permisos de Trabajo" }]

// Voolks Sheets
siteConfig.sheetsApiBase = siteConfig.sheetsApiBase || "https://sheets.voolks.com/api" // "http://localhost:4300/api"
// siteConfig.sheetsApiBase = "https://sheets-test.voolks.com/api"
// siteConfig.sheetsApiBase = "http://localhost:4300/api"

siteConfig.sheetsFrontUrl = siteConfig.sheetsFrontUrl || "https://sheets.voolks.com" // "http://localhost:5173";
// siteConfig.sheetsFrontUrl = "http://localhost:5173";

//module.exports = siteConfig;